﻿export interface IRange {
    min: number;
    max: number;
}

export class Range implements IRange {
    public min: number;
    public max: number;
}